import React from "react";

// mirrors the server-rendered skeleton in main-dealer-locator.liquid so
// there's no visual flash switching from the liquid skeleton to this one
// once React mounts, while dealers are still being fetched/filtered.
const ResultsLoading = () => {
  return (
    <>
      <div className="ft_dealer-locator__results__utility-bar">
        <span className="skeleton skeleton--title" style={{ "--skeleton-text-width": "300px" }}></span>
      </div>
      {[...Array(4)].map((_, index) => (
        <div key={index} className="ft_dealer-locator__results__list__item rounded-lg v-stack gap-3" style={{ borderColor: "var(--light-grey)" }}>
          <span className="skeleton skeleton--title" style={{ "--skeleton-text-width": "50%" }}></span>
          <span className="skeleton skeleton--text" style={{ "--skeleton-text-width": "60%" }}></span>
          <span className="skeleton skeleton--text" style={{ "--skeleton-text-width": "90%" }}></span>
          <span className="skeleton skeleton--text" style={{ "--skeleton-text-width": "40%" }}></span>
        </div>
      ))}
    </>
  );

}

export default ResultsLoading;
